import { CardPayment, getCardPaymentById, SinglePaymentStatus } from '@nemuru-eng/js-api-client';

import { SinglePaymentStatusViewStatus } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/_shared/types';
import { AbstractSinglePaymentProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/_shared/entities/Progress/AbstractSinglePaymentProgress';

export class CardPaymentProgress extends AbstractSinglePaymentProgress {
  protected _singlePayment: CardPayment | undefined;

  protected async fetchStatuses(): Promise<SinglePaymentStatusViewStatus[]> {
    this._singlePayment = await getCardPaymentById({ cardPaymentId: this._paymentMethodId });

    const initialStatus = {
      status: SinglePaymentStatus.PENDING,
      updatedAt: this._singlePayment.createdAt,
      detail: null,
    };

    if (this._singlePayment.status === SinglePaymentStatus.PENDING) {
      return [initialStatus];
    }

    return [
      initialStatus,
      {
        status: this._singlePayment.status,
        updatedAt: this._singlePayment.updatedAt,
        detail: null,
      },
    ];
  }
}
